import '@css/bestcosme/common.scss'
import '@css/bestcosme/2025.scss'

$(function () {
  // $('.anchor_link').click(function (event) {
  //   event.preventDefault();
  //   $('html, body').animate({
  //     scrollTop: $($.attr(this, 'href')).offset().top
  //   }, 500, 'swing');
  // });

  // main page top slider
  let grand_slider_owl = $('#grand_owl_carousel .js_grand_owl_carousel').owlCarousel({
    items: 1,
    loop: true,
    dots: false,
    // autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true
  });
  $("#grand_owl_carousel .slidesjs-next").click(function () {
    grand_slider_owl.trigger('next.owl.carousel');
  });
  $("#grand_owl_carousel .slidesjs-previous").click(function () {
    grand_slider_owl.trigger('prev.owl.carousel', [300]);
  });

  let down_newstar_slider_owl = $('#down_newstar_owl_carousel .js_down_newstar_owl_carousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    center: true,
    // autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    items: 3
  });
  $("#down_newstar_owl_carousel .slidesjs-next").click(function () {
    down_newstar_slider_owl.trigger('next.owl.carousel');
  });
  $("#down_newstar_owl_carousel .slidesjs-previous").click(function () {
    down_newstar_slider_owl.trigger('prev.owl.carousel', [300]);
  });

  // 使用 Intersection Observer 監測元素是否進入視口
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.8 // 當 80% 的元素進入視口時觸發
  };

  const carouselConfigs = [
    { element: $('.js_grand_owl_carousel'), owl: grand_slider_owl, timeout: 4000 },
    // { element: $('#hall_slider_items'), owl: hall_slider_owl, timeout: 4000 },
    // { element: $('#down_newstar_slider_items'), owl: down_newstar_slider_owl, timeout: 4000 },
    // { element: $('#tw_jp_slider_items'), owl: tw_jp_slider_owl, timeout: 4000 }
  ];

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const config = carouselConfigs.find(c => c.element[0] === entry.target);
        if (config && config.owl) {
          // 開始 autoplay
          config.owl.trigger('play.owl.autoplay', [config.timeout]);
          // 只需要啟動一次，所以停止觀察
          observer.unobserve(entry.target);
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 觀察所有輪播元素
  carouselConfigs.forEach(config => {
    if (config.element.length > 0) {
      observer.observe(config.element[0]);
    }
  });

}); 
